import { ERROR_MESSAGE } from '@/constants';
import CloseIcon from '@mui/icons-material/Close';
import { DialogActions, LinearProgress } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import React, { ReactNode } from 'react';
import Banner, { BannerColour } from '../Banner/Banner';
import { colorPalette } from '../Theme/colors';
import styles from './CustomDialog.module.scss';

interface CustomDialogProps {
  title: string;
  children?: ReactNode;
  onClose?: () => void;
  buttons?: ReactNode;
  icon?: ReactNode;
  isProgressBar?: boolean;
  disableForceClose?: boolean;
  displayErrorBanner?: boolean;
}

const CustomDialog: React.FC<CustomDialogProps> = ({
  title,
  children,
  onClose,
  buttons,
  icon, // this shows an icon next to the title
  isProgressBar = false, // this shows a progress bar alone as its content
  disableForceClose = false,
  displayErrorBanner = false,
}) => {
  return (
    <Dialog
      open={true}
      onClose={disableForceClose ? undefined : onClose}
      disableEscapeKeyDown={disableForceClose}
      className={styles.dialogBox}
    >
      <div className={styles.dialogHeader}>
        {disableForceClose === false && (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 0,
              top: 0,
              padding: '5px',
              color: 'white',
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
      </div>

      {/* Error banner */}
      {displayErrorBanner && (
        <Banner
          color={BannerColour.RED}
          icon="error"
          iconColor={colorPalette.red.main}
          sx={{
            margin: '10px 20px 20px 20px',
            width: 'unset',
          }}
        >
          {ERROR_MESSAGE}
        </Banner>
      )}

      <div className={styles.dialogTitleContainer}>
        {icon && <div className={styles.dialogIcon}>{icon}</div>}
        <h5 className={styles.dialogTitle}>{title}</h5>
      </div>

      {isProgressBar ? (
        <div className={styles.progressBar}>
          <LinearProgress sx={{ height: '15px' }} />
        </div>
      ) : (
        <>
          <div className={styles.dialogContent}>
            <div className={styles.dialogBody}>{children}</div>
          </div>
          <DialogActions className={styles.dialogActions}>
            {buttons}
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default CustomDialog;
